import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

const useSearchParam = (param: string) => {
  const [searchParams] = useSearchParams();
  return useMemo(() => {
    return searchParams.get(param);
  }, [searchParams]);
};
export default useSearchParam;
